
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/company/officer",
      function () {
        return require("private-next-pages/en/company/officer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/company/officer"])
      });
    }
  